import {UserInfoEntity} from "@/entity/UserInfoEntity";
import {Base} from "@/dto/Base";
export class UserInfoEntityDto {
    public static url = '/api/uie';

    public static async selectCompanyInfo(u: UserInfoEntity): Promise<UserInfoEntity[]> {
        const  response = await Base.postWithToken(this.url + '/selectCompanyInfo',u) as any;
        const userInfoEntitys = response.data as UserInfoEntity[];
        return  userInfoEntitys;
    }
}
//
//
